/* eslint-disable no-dupe-keys */
import './Question.scss';
import React, {useRef, useState} from 'react';
import MandatoryBadge from '../MandatoryNotification/MandatoryNotification';
import {Alert, Card, Col, Container, Row} from 'react-bootstrap';
import {FmlxButton, FmlxCheckBox, FmlxIcon, FmlxLabel} from 'fmlx-common-ui';
import {Rating} from '../../SimpleStarRating';
import {FMLX_BUTTON, FMLX_COMPONENT} from '../../const/FmlxComponentEnum';
import {EQuestionCategory, fillColorArray, iconArray, QUESTION_TYPE, QuestionClassname} from '../../const/dataEnum';
import {TextareaAutosize} from '@mui/base';
import {hasQuestionAnswered, showButtonClear} from '../../stores/business/reviewTaskBusiness';

// const tooltipArray = {
//   5: ["Terrible", "Bad", "Average", "Great", "Awesome"],
//   10: ["Terrible", "Terrible+", "Bad", "Bad+", "Average", "Average+", "Great", "Great+", "Awesome", "Awesome+"],
// };
// const tooltipArray = {
//   5: ["1", "2", "3", "4", "5"],
//   10: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
// };

/**
 *
 * @param {*} props
 * title : Question title
 * description : Question Description
 * minText : Min title for rating
 * maxText : Max title for rating
 * updateRating : Function that handle update rating
 * score : Score for rating
 * updateComments : Function that handle update rating
 * readonly : Read only ?
 * @returns
 */
export default function Question(props) {
  const {
    title,
    description,
    readOnly,
    comment,
    score,
    required,
    updateComments,
    questionType,
    commentsRequired,
    isNotQualified,
    minimumofWords,
    onReset,
    onNotQulifiedChange,
    minText,
    updateRating,
    maxText,
    showAlert,
    category,
  } = props;

  const wordCount = title === '' || comment.trim() === '' ? 0 : comment.trim().split(/\s+/).length;
  const [errMinWords, setErrMinWords] = useState(wordCount > 0 && wordCount < Number(minimumofWords));
  const inputRef = useRef(null);
  const reviewRadios = new Array(
    questionType === QUESTION_TYPE.SCORE_20
      ? 20
      : questionType === QUESTION_TYPE.SCORE_10
        ? 10
        : questionType === QUESTION_TYPE.SCORE_5
          ? 5
          : questionType === QUESTION_TYPE.SCORE_4
            ? 4
            : 0
  ).fill(0);
  const isButtonHide = hasQuestionAnswered(props);
  const hasCheckCommentValue = !comment || comment.trim() === '';
  const hasCheckScoreRatting = score === 0 || score === null || score === undefined;
  const conditionalBadgeShow = (!isButtonHide && required) || !isButtonHide; //|| hasCheckCommentValue;
  const isButtonClearShown = showButtonClear(props);

  const generateQuestionTitleClassName = () => {
    const className = [QuestionClassname.questionTitle];

    if (questionType === QUESTION_TYPE.ESSAY) {
      if (!readOnly && hasCheckCommentValue) {
        className.push(QuestionClassname.questionTitleHighlight);
      }
    } else {
      if (!readOnly && (hasCheckCommentValue || hasCheckScoreRatting)) {
        className.push(QuestionClassname.questionTitleHighlight);
      }
    }

    return className;
  };
  const questionTitleClassName = generateQuestionTitleClassName();

  const handleOnChangeComment = (e) => {
    updateComments(e);
    setErrMinWords(false);
  };

  const handleOnBlurComment = () => {
    const color = wordCount > 0 && wordCount < Number(minimumofWords);
    setErrMinWords(color);
  };


  return (
    <Card className="mb-4 reviewTask-question">
      <Card.Img variant="top"/>
      <Card.Body>
        <Card.Title className="question-title">
          <Row>
            <Col className={questionTitleClassName}>
              <div className='title-container'>
                {(required || commentsRequired) && !isNotQualified && (
                  <MandatoryBadge
                    size={'sm'}
                    className={'mandatory-badge-warning'}
                    checkValue={conditionalBadgeShow}
                    customColor={'#d90429'}
                    label={'Mandatory'}
                    iconName={'Warning'}
                    // title={props.title}
                  />
                )}
                <div className='title-component'>
                  {title}
                </div>
              </div>
            </Col>
            {!readOnly && isButtonClearShown && (
              <Col className="reviewTask-question--action-wrapper" sm={2}>
                <FmlxButton
                  size={FMLX_COMPONENT.SIZE.S}
                  type={FMLX_BUTTON.TYPE.DANGER}
                  variant={FMLX_BUTTON.VARIANT.OUTLINE}
                  disabled={isNotQualified}
                  label="Clear"
                  onClick={onReset}
                  className="clear-button"
                  withIcon={FMLX_BUTTON.WITH_ICON.END}
                  icon={<FmlxIcon name={'RotateCcw'}/>}
                  withTooltip={false}
                  tooltipPlacement={'top'}
                  tooltipDescription={'Delete Question'}
                />
              </Col>
            )}
          </Row>
        </Card.Title>
        <Card.Body className="question-card-body">
          {readOnly || category === EQuestionCategory.GENERAL ? null : (
            <div className="mb-1">
              <FmlxCheckBox
                label="Not qualified to answer"
                checked={isNotQualified}
                onChange={onNotQulifiedChange}
              />
            </div>
          )}
          {description !== null && description.trim() !== '' && (
            <div className="description-text">{description}</div>
          )}
          {questionType !== 'essay' && (
            <Container>
              <Row className="score-row">
                <Col className="min-text">{minText}</Col>
                {reviewRadios.length > 0 && (
                  <Col className="p-2 bd-highlight score-wrapper">
                    <Row className="score-content">
                      <Col sm={8} className="rating-container">
                        <Rating
                          id={`rating-question--${title}`}
                          onClick={readOnly ? () => {
                          } : updateRating}
                          initialValue={score}
                          iconsCount={reviewRadios.length}
                          stars={reviewRadios.length}
                          ratingValue={score}
                          readonly={readOnly || isNotQualified}
                          className={'ratingDotPoin'}
                          customIcons={iconArray[reviewRadios.length]}
                          fillColorArray={fillColorArray[reviewRadios.length]}
                        />
                      </Col>
                    </Row>
                  </Col>
                )}
                <Col className="max-text">{maxText}</Col>
              </Row>
            </Container>
          )}

          <div className="mt-4 mb-4">
            <FmlxLabel id="reviewTask-question--title" label={'Comment'} required={commentsRequired}/>
            <TextareaAutosize
              className="question--textarea"
              placeholder={
                commentsRequired
                  ? 'please provide a comment...'
                  : 'Optional - You can give suggestion or comment for this question...'
              }
              maxLength={2048}
              disabled={readOnly || isNotQualified}
              onChange={(e) => handleOnChangeComment(e)}
              ref={inputRef}
              value={comment}
              minRows={1}
              maxRows={4}
              onBlur={handleOnBlurComment}
            />
            {commentsRequired && !isNotQualified ? (
              <>
                {minimumofWords > 0 && wordCount === 0 && (
                  <FmlxLabel label={`Minimum ${minimumofWords} words`}/>
                )}
                {wordCount > 0 && wordCount < Number(minimumofWords) && (
                  <div className={`${errMinWords ? 'question--errMinWords' : ''}`}>
                    <FmlxLabel label={`${Number(minimumofWords) - wordCount} words to go...`}/>
                  </div>
                )}
              </>
            ) : null}
          </div>
          <div>
            {showAlert && required ? <Alert variant="warning">This is a required field</Alert> : ''}
          </div>
        </Card.Body>
      </Card.Body>
    </Card>
  );
}